import { render } from "./CalendarSolidIcon.vue?vue&type=template&id=b11372b8"
import script from "./CalendarSolidIcon.vue?vue&type=script&lang=js"
export * from "./CalendarSolidIcon.vue?vue&type=script&lang=js"
script.render = render

export default script